import { ErrorCode, i18nKey, } from "@shared";
export function prizeView(content, reader) {
    const finished = reader.now >= Number(content.endDate);
    const claimedByYou = content.userIsWinner;
    const allClaimed = content.prizesRemaining <= 0;
    const gates = [];
    if (content.lifetimeDiamondOnly) {
        gates.push({
            label: i18nKey("prizes.lifetimeDiamondMembership"),
            met: reader.lifetimeDiamond,
        });
    }
    else if (content.diamondOnly) {
        gates.push({ label: i18nKey("prizes.diamondMembership"), met: reader.diamond });
    }
    if (content.streakOnly > 0) {
        gates.push({
            label: i18nKey("prizes.streakFull", { n: content.streakOnly }),
            met: reader.streak >= content.streakOnly,
        });
    }
    if (content.minChitEarned > 0) {
        gates.push({
            label: i18nKey("prizes.minChitEarnedValue", { n: content.minChitEarned }),
            met: reader.chitEarned >= content.minChitEarned,
        });
    }
    const eligible = (!content.diamondOnly || reader.diamond) &&
        (!content.lifetimeDiamondOnly || reader.lifetimeDiamond) &&
        content.streakOnly <= reader.streak &&
        content.minChitEarned <= reader.chitEarned;
    return {
        finished,
        claimedByYou,
        allClaimed,
        eligible,
        canClaim: !reader.direct &&
            !reader.mine &&
            !reader.previewingOrLapsed &&
            !finished &&
            !claimedByYou &&
            !allClaimed &&
            eligible,
        gates,
    };
}
/**
 * The custom data a prize's human check (Cloudflare Turnstile) is run with. The LocalUserIndex
 * checks the token it issues was for this, so it serves only this user's claim of this prize.
 */
export function prizeClaimCustomData(userId, messageId) {
    return `${userId}_${messageId}`;
}
/** What to tell the user when a prize claim fails: a human check the backend refused can be retried. */
export function claimPrizeFailureReason(response) {
    return response.kind === "error" && response.code === ErrorCode.HumanVerificationFailed
        ? i18nKey("prizes.humanCheckFailed")
        : i18nKey("prizes.claimFailed");
}
/** A click the user made: a script's synthetic click can't claim a prize (claimPrize). */
export function isTrustedClick(e) {
    return e instanceof MouseEvent && e.isTrusted && e.type === "click";
}
